import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/supply/page.jsx")